export const sortResults = [
	{
		text: 'Relevance',
		type: 'none',
		value: 'none',
	},
	{
		text: 'Released',
		type: 'ascending',
		value: 'released',
	},
	{
		text: 'Released',
		type: 'descending',
		value: '-released',
	},
	{
		text: 'Metacritic',
		type: 'ascending',
		value: 'metacritic',
	},
	{
		text: 'Metacritic',
		type: 'descending',
		value: '-metacritic',
	},
];
